module.exports = __webpack_public_path__ + "img/color-10.4be1360.png";